<!--
 * @author: liqian
 * @date: Do not Edit
 * @description: 封装全局的loading组件
-->
<template>
  <div class="fd-loading" v-if='spinning'>
    <a-spin class="fd-loading-icon"></a-spin>
  </div>
</template>

<script>
  export default {
    props: ['loadingFlag'],
    watch: {
      '$store.state.publics.axiosNum': {
        handler(val) {
        //   let hideLoding = this.$store.state.publics.hideLoding && this.$route.path == '/modules/home/home';
          this.spinning = val > 0 ? true : false;
        },
        immediate: true
      }
    },
    data() {
      return {
        spinning: false
      }
    }
  }
</script>

<style scoped>
  .fd-loading {
    position: fixed;
    margin: auto;
    z-index: 9999;
    height: 100%;
    width: 100%;
    color: transparent;
    text-shadow: none;
    background: rgba(255, 255, 255, 0.5);
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 0;
  }

  .fd-loading-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 10000;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/comLoading.vue